"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCreateReview = void 0;
var _auth = require("@ori/auth");
var _environment = require("@ori/environment");
var _fetching = require("@ori/fetching");
var _globalApiClientReact = require("@ori/global-api-client-react");
var _i18n = require("@ori/i18n");
var _react = require("react");
var _constants = require("../constants");
var _ratingAndReviewDialogContext = require("../contexts/ratingAndReviewDialogContext");
var _resultContext = require("../contexts/resultContext");
var _hooks = require("../hooks");
var _utils = require("../utils");
const useCreateReview = () => {
  const {
    customerId,
    isUserVerified
  } = (0, _auth.useToken)();
  const {
    tenant
  } = (0, _environment.useEnvironment)();
  const {
    language
  } = (0, _i18n.useLanguage)();
  const globalApiClient = (0, _globalApiClientReact.useApiClient)();
  const {
    translations
  } = (0, _hooks.useTranslations)();
  const {
    orderId,
    productCode: productCodeFromEvent,
    onClose: onRatingAndReviewDialogClose,
    onSuccessCreate
  } = (0, _ratingAndReviewDialogContext.useRatingAndReviewDialog)();
  const {
    onOpen: onResultDialogOpen
  } = (0, _resultContext.useResultDialog)();
  return (0, _react.useCallback)(formValues => {
    const {
      productCode: productCodeFromForm
    } = formValues;
    const productCode = productCodeFromForm ?? productCodeFromEvent;
    if (!isUserVerified || !productCode) {
      return;
    }
    (0, _globalApiClientReact.createApplicationsCustomerFeedbackCustomerReview)(globalApiClient, String(customerId), (0, _utils.parseFormValues)({
      customerId,
      formValues,
      orderId,
      productCode: productCodeFromEvent
    }), {
      [_constants.ACCEPT_LANGUAGE]: language,
      [_fetching.TENANT_CONTEXT]: tenant
    }).then(() => {
      onResultDialogOpen({
        content: translations.reviewSuccessDescription,
        header: translations.reviewSuccessTitle,
        severity: 'success'
      });
      onSuccessCreate?.();
    }).catch(() => {
      onResultDialogOpen({
        content: translations.reviewFailDescription,
        header: translations.reviewFailTitle,
        severity: 'error'
      });
    }).finally(() => {
      onRatingAndReviewDialogClose();
    });
  }, [customerId, globalApiClient, isUserVerified, language, onRatingAndReviewDialogClose, onResultDialogOpen, onSuccessCreate, orderId, productCodeFromEvent, tenant, translations.reviewFailDescription, translations.reviewFailTitle, translations.reviewSuccessDescription, translations.reviewSuccessTitle]);
};
exports.useCreateReview = useCreateReview;
